import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBatteryEmpty"><Path d="M1.5 5.5H19.5V18.5H1.5V5.5Z" stroke="currentColor"/><Path d="M19.5 8.5H22.5V15.5H19.5V8.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconBatteryEmpty;
